// Authoritative product imagery — served same-origin from /public/images/product/
// so production at peptidecooler.co.uk no longer depends on the emergent CDN
// (which CORS-restricts external origins). All references across hero, PDP
// gallery, showcase, thumbnails and Open Graph share-cards resolve through
// these local paths.
export const IMG = {
  // 1) Hero 3/4 angle — Peptigen Labs logo on the front face
  hero: "/images/product/cooler-hero.png",
  // 2) Alt 3/4 angle, white background
  altAngle: "/images/product/cooler-alt.png",
  // 3) LID OPEN — vials visible inside (highest-converting frame)
  openLid: "/images/product/cooler-open.png",
  // 4) Lifestyle on marble countertop
  lifestyle: "/images/product/cooler-lifestyle.png",
};

// Canonical 4-image catalogue, ordered for the PDP gallery carousel.
// (1) front 3/4 → (2) alt angle → (3) lid open → (4) lifestyle
export const PRODUCT_IMAGES = [IMG.hero, IMG.altAngle, IMG.openLid, IMG.lifestyle];

export const PRODUCT_IMAGE_ALTS = [
  "PeptiChill cooler — front three-quarter angle with Peptigen Labs logo on the front face",
  "PeptiChill cooler — alternate three-quarter angle on a clean white background",
  "PeptiChill cooler — top lid open, showing internal organisation tray and vials with the LCD reading 2°C",
  "PeptiChill cooler on a white marble countertop in a premium home setting",
];

export const SITE = {
  name: "PeptiChill",
  tagline: "Precision cooling for peptide storage.",
  parent: "Peptigen Labs",
  parentUrl: "https://peptigenlabs.co.uk",
  email: "hello@peptidecooler.co.uk",
  shipNote: "Ships July 2026",
};
